import { useState, useEffect } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import { useAuth } from "context";
import moon from "../../../assets/images/icons/catering-icons/greenMoon.svg";
import sun from "../../../assets/images/icons/catering-icons/greenSun.svg";
import profile from "../../../assets/images/icons/catering-icons/profileIconGreen.svg";
import darkModeprofile from "../../../assets/images/icons/catering-icons/darkModeProfile.svg";
import dashboardLogo from "../../../assets/images/icons/catering-rewards/blackBottomLogo.svg";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

function DashboardNavbar({ absolute, light, isMini, title, subtitle }) {
  const [navbarType, setNavbarType] = useState();
  const {
    transparentNavbar,
    fixedNavbar,
    darkMode,
    setTransparentNavbar,
    setDarkMode,
    verifiedCustomer,
    miniSidenav,
    setMiniSidenav,
  } = useAuth();
  const route = useLocation().pathname.split("/").slice(1);
  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar((fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [fixedNavbar]);
  const handleMiniSidenav = () => setMiniSidenav(false);
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  return (
    <AppBar
      position={"fixed"}
      color={darkMode ? "white" : "black"}
      sx={(theme) =>
        navbar(theme, {
          absolute,
          light,
          darkMode,
        })
      }
      style={{
        backgroundColor: darkMode ? "#131A36" : "#ffffff",
        borderRadius: "0",
        color: darkMode ? "white" : "black",
        marginTop: "-12px",
        height: "5%",
      }}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          mx={2}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          <MDBox
            sx={{
              marginLeft: "215px",
              marginBottom: "-15px",
              "@media (max-width:767px)": {
                marginLeft: "80px",
              },
            }}
          >
            {!miniSidenav && (
              <MDBox>
                <Breadcrumbs icon="home" title={title || route[route.length - 1]} light={light} />
              </MDBox>
            )}

            {isMini ? null : (
              <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
                <MDBox
                  color={light ? "white" : "inherit"}
                  sx={{
                    "@media (max-width:767px)": {
                      marginLeft: "-80px",
                      display: "flex",
                    },
                    "@media (max-width: 998px) and (min-width: 768px)": {
                      marginLeft: "-225px",
                      display: "flex",
                    },
                  }}
                >
                  <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    sx={navbarMobileMenu}
                    onClick={handleMiniSidenav}
                  >
                    <Icon sx={iconsStyle} fontSize="medium">
                      {miniSidenav ? "menu_open" : "menu"}
                    </Icon>
                  </IconButton>
                  {miniSidenav && <MDAvatar src={dashboardLogo} alt="logo" />}
                </MDBox>
              </MDBox>
            )}
          </MDBox>

          <MDBox
            sx={{
              display: "flex",
              gap: 1,
              paddingTop: "10px",
              "@media (max-width:767px)": {
                marginRight: "10px",
                gap: 1,
              },
            }}
          >
            {/* <MDBox>
              {darkMode ? (
                <MDBox
                  component="img"
                  src={moon}
                  alt="Moon"
                  width="1.5rem"
                  sx={{ cursor: "pointer", marginRight: 1 }}
                  onClick={() => {
                    setDarkMode(!darkMode);
                    localStorage.setItem("darkMode", JSON.stringify(!darkMode));
                  }}
                />
              ) : (
                <MDBox
                  component="img"
                  src={sun}
                  alt="sun"
                  width="1.5rem"
                  sx={{ cursor: "pointer", marginRight: 1 }}
                  onClick={() => {
                    setDarkMode(!darkMode);
                    localStorage.setItem("darkMode", JSON.stringify(!darkMode));
                  }}
                />
              )}
            </MDBox> */}
            <MDBox>
              {darkMode ? (
                <MDBox
                  component="img"
                  src={darkModeprofile}
                  alt="profile"
                  width="1.5rem"
                  sx={{ marginRight: 1 }}
                />
              ) : (
                <MDBox
                  component="img"
                  src={profile}
                  alt="profile"
                  width="1.5rem"
                  sx={{ marginRight: 1 }}
                />
              )}
            </MDBox>
            {verifiedCustomer && <Breadcrumbs title={verifiedCustomer?.firstName} />}
          </MDBox>
        </MDBox>
      </Toolbar>
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          mx={2}
          mt={"-4px"}
          sx={(theme) => navbarRow(theme, { isMini })}
        >
          {subtitle && <Breadcrumbs title={subtitle} light={light} />}
        </MDBox>
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default DashboardNavbar;
